import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, LogIn } from "lucide-react";

const HERO = "https://customer-assets-lxgj4vgw.emergentagent.net/job_coop-control-11/artifacts/cdm8r5pq_WhatsApp%20Image%202026-08-19%20at%2013.25.20.jpeg";
const LOGO = "https://customer-assets-lxgj4vgw.emergentagent.net/job_coop-control-11/artifacts/r51dsgro_image.png";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
    } catch (e2) {
      setErr(errMsg(e2, "Giriş başarısız"));
    } finally {
      setLoading(false);
    }
  };

  const forgot = async () => {
    const em = window.prompt("Şifre sıfırlama bağlantısı gönderilecek e-posta:", email);
    if (!em) return;
    try {
      await api.post("/auth/forgot-password", { email: em.trim() });
      toast.success("Kayıtlıysa, sıfırlama bağlantısı e-postanıza gönderildi");
    } catch {
      toast.error("İşlem başarısız");
    }
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <img src={HERO} alt="Mim Gıda Kümes" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/60" />
      <div className="relative min-h-screen flex items-center justify-center lg:justify-end px-6 lg:px-24 py-10">
        <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-black/40 backdrop-blur-md border border-white/15 p-7 text-white shadow-2xl" data-testid="login-form">
          <div className="flex items-center gap-2.5 mb-6">
            <img src={LOGO} alt="MİM GIDA" className="h-10 w-10 rounded-lg object-cover" />
            <span className="font-head font-extrabold text-2xl tracking-tight">MİM GIDA</span>
          </div>
          <h1 className="font-head text-2xl font-bold tracking-tight mb-6">Mim Gıda Kümes Takip Paneli</h1>

          {err && <div className="mb-4 rounded-lg bg-red-500/25 text-white text-sm px-3 py-2.5 border border-red-300/30" data-testid="login-error">{err}</div>}

          <label className="block text-[11px] uppercase tracking-wide font-semibold text-white/70 mb-1.5">E-posta</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
            className="h-11 w-full rounded-lg border border-white/25 bg-white/10 text-white placeholder-white/40 px-3 text-sm mb-4 focus:ring-2 focus:ring-primary outline-none" placeholder="ornek@mimgida.com" />

          <label className="block text-[11px] uppercase tracking-wide font-semibold text-white/70 mb-1.5">Şifre</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
            className="h-11 w-full rounded-lg border border-white/25 bg-white/10 text-white placeholder-white/40 px-3 text-sm mb-6 focus:ring-2 focus:ring-primary outline-none" placeholder="••••••••" />

          <button type="submit" disabled={loading} data-testid="login-submit"
            className="h-11 w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-50">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <LogIn size={18} />} Giriş Yap
          </button>
          <button type="button" onClick={forgot} data-testid="forgot-link" className="mt-4 text-sm text-white/80 hover:text-white hover:underline w-full text-center">Şifremi unuttum?</button>
        </form>
      </div>
    </div>
  );
}
